import { useTranslation } from 'next-i18next';

import useMockInterviewsTypesQuery from '../../../../queries/useMockInterviewsTypesQuery';

/** 서버 displayName 은 lang 과 무관하게 한국어로만 내려와서, 아는 code 는 locale 키로 번역한다. */
const JOB_NAME_KEY = {
  BACKEND: 'ai_interviews.job_type.backend',
  FDE: 'ai_interviews.job_type.fde',
  FRONTEND: 'ai_interviews.job_type.frontend',
} as const;

const isKnownJobCode = (code: string): code is keyof typeof JOB_NAME_KEY => code in JOB_NAME_KEY;

/** 지원 직무 표시명 목록. 로딩·에러 시 빈 배열이라 호출부는 비었을 때 숨기기만 하면 된다. */
export const useMockInterviewJobNames = (): string[] => {
  const { t } = useTranslation();
  const { data } = useMockInterviewsTypesQuery({
    options: { staleTime: 1_000 * 60 * 10 },
  });

  return (
    data?.items.map((item) =>
      isKnownJobCode(item.code) ? t(JOB_NAME_KEY[item.code]) : item.displayName,
    ) ?? []
  );
};
